module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/social/xing-08e90b330259cf4f36833c4e3b94f94f.svg";